const dbNotif = "Make sure to replace empty cells with 'None' value. Share a valid source URL for data !" 
const dbWeb= "Try to keep the image size less than 2MB ! Share the handpicked images rather than whole gallery." 

export {dbNotif, dbWeb}